<template>
  <div class="text-editor">
    <div id="toolbar">
      <select class="ql-size">
        <option value="small">Small</option>
        <option value="">Normal</option>
        <option value="large">Large</option>
        <option value="huge">Huge</option>
      </select>
      <select class="ql-header">
        <option value="1">H1</option>
        <option value="2">H2</option>
        <option value="3">H3</option>
        <option value="4">H4</option>
        <option value="5">H5</option>
        <option value="6">H6</option>
        <option selected>Normal</option>
      </select>
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>
      <button class="ql-code-block"></button>
      <select class="ql-color">
        <option value="#000000">#000000</option>
        <option value="#ffffff">#ffffff</option>
        <option value="#ff0000">#ff0000</option>
        <option value="#00ff00">#00ff00</option>
        <option value="#0000ff">#0000ff</option>
        <option value="#FFEFD6">#FFEFD6</option>
        <option value="#FBE1C4">#FBE1C4</option>
      </select>
      <select class="ql-background">
        <option selected></option> <!-- Transparan, yani stil uygulanmayan -->
        <option value="#fce5cd">#fce5cd</option>
        <option value="#d9ead3">#d9ead3</option>
        <option value="#cfe2f3">#cfe2f3</option>
        <option value="#f4cccc">#f4cccc</option>
        <option value="#fff2cc">#fff2cc</option>
        <option value="#d0e0e3">#d0e0e3</option>
        <option value="#ead1dc">#ead1dc</option>
      </select>
      <button class="ql-link"></button>
      <button class="ql-list" value="ordered"></button>
      <button class="ql-list" value="bullet"></button>
      <button class="ql-indent" value="-1"></button>
      <button class="ql-indent" value="+1"></button>
      <select class="ql-align">
        <option selected></option>      <!-- Sol -->
        <option value="center"></option> <!-- Ortala -->
        <option value="right"></option>  <!-- Sağa hizala -->
        <option value="justify"></option> <!-- İki yana yasla -->
      </select>
      <button class="ql-image"></button>
      <button class="ql-clean"></button>
    </div>

    <div id="editor" ref="quillEditor"></div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import Swal from "sweetalert2";

export default {
  name: "TextEditor",
  props: {
    modelValue: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      savedRange: null
    }
  },
  emits: ["update:modelValue"],
  mounted() {
    if (this.$refs.quillEditor) {
      this.quill = new Quill(this.$refs.quillEditor, {
        theme: "snow",
        modules: {
          toolbar: {
            container: "#toolbar",
            handlers: {
              image: async () => {
                const { value: option } = await Swal.fire({
                  title: "Görsel Ekle",
                  text: "Nasıl eklemek istersiniz?",
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonText: "Dosya Yükle",
                  cancelButtonText: "URL ile Ekle"
                });

                if (option) {
                  const input = document.createElement("input");
                  input.setAttribute("type", "file");
                  input.setAttribute("accept", "image/png, image/jpeg, image/jpg");
                  input.click();

                  input.onchange = () => {
                    const file = input.files[0];
                    const allowedExtensions = [".png", ".jpg", ".jpeg"];
                    const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

                    if (allowedExtensions.includes(fileExtension)) {
                      this.addImages(file);
                    } else {
                      Swal.fire("Hata", "Sadece .png, .jpg veya .jpeg dosyalarına izin verilir.", "error");
                    }
                  };
                } else {
                  this.savedRange = this.quill.getSelection();

                  const { value: imageUrl } = await Swal.fire({
                    title: "Görsel URL’si Girin",
                    input: "url",
                    inputLabel: "Görselin tam URL’si",
                    inputPlaceholder: "https://cdn.example.com/image.jpg",
                    showCancelButton: true,
                    confirmButtonText: "Ekle",
                    cancelButtonText: "İptal",
                    inputValidator: (value) => {
                      if (!value || !/^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)$/i.test(value)) {
                        return "Geçerli bir görsel URL’si girin (jpg, png, gif, webp)";
                      }
                    }
                  });

                  if (imageUrl) {
                    this.insertToEditor(imageUrl);
                  }
                }
              }
            }
          }
        }
      });


      this.quill.on("text-change", () => {
        this.$emit("update:modelValue", this.quill.root.innerHTML);
      });

      this.quill.on("selection-change", (range) => {
        if (range === null || !this.quill.composing) {
          this.quill.update();
        }
      });
      this.quill.root.innerHTML = this.modelValue;
    }
  },
  watch: {
    modelValue(newValue) {
      if (this.quill && newValue !== this.quill.root.innerHTML) {
        const selection = this.quill.getSelection();
        this.quill.root.innerHTML = newValue;
        if (selection) {
          this.quill.setSelection(selection);
        }
      }
    }
  },
  methods: {
    addImages(file) {
      const formData = new FormData();
      formData.append("file", file);

      this.$appAxios.post("/admin/image/upload-image-cdn", formData).then((res) => {
        const imageUrl = res.data.imageUrl;
        this.insertToEditor(imageUrl);
      });
    },
    insertToEditor(url) {
      const range = this.savedRange || this.quill.getSelection();
      const index = range ? range.index : this.quill.getLength();
      this.quill.insertEmbed(index, "image", url);
      this.quill.insertText(index + 1, '\n');
      this.quill.setSelection(index + 2);
      this.savedRange = null;
    }
  }
};
</script>

<style>
.text-editor {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}
</style>
